import { CardMenuDetail } from '@/components/Timeline/TimelineItems/CardMenu';
import { formatPhoneNumber } from '@bariendo/lib/phone-validations';

export interface PhoneCardDetailsInput {
  /** The patient's (or partner's) end of the conversation, E.164. */
  patientNumber?: string;
  /** Our end. A text thread can span several when the from-number rules change
   * mid-conversation, so this is a list even though a call only ever has one. */
  orbitNumbers?: string[];
  /** The contact label the chart carries for the patient number — "Mobile",
   * "Home". Shown in parentheses when we have one. */
  patientLabel?: string;
}

/**
 * The **Details** rows for a call or text card: the two ends of the line,
 * shown formatted and copied as E.164 — what a dialer or Twilio console wants.
 *
 * The Everself side earns its slot because two threads on different market
 * numbers look identical on the card, and which line a reply leaves on decides
 * whether it joins the thread or starts a new one.
 */
export function buildPhoneCardDetails({
  patientNumber,
  orbitNumbers = [],
  patientLabel,
}: PhoneCardDetailsInput): CardMenuDetail[] {
  const details: CardMenuDetail[] = [];

  if (patientNumber?.trim()) {
    const formatted = formatPhoneNumber(patientNumber);
    details.push({
      label: 'Patient',
      value: patientLabel ? `${formatted} (${patientLabel})` : formatted,
      copyValue: patientNumber,
    });
  }

  // Deduped, order preserved.
  const distinctOrbitNumbers = orbitNumbers.filter(
    (number, index) => number?.trim() && orbitNumbers.indexOf(number) === index
  );

  for (const orbitNumber of distinctOrbitNumbers) {
    details.push({
      label: 'Orbit',
      value: formatPhoneNumber(orbitNumber),
      copyValue: orbitNumber,
    });
  }

  return details;
}
